import { render, staticRenderFns } from "./RegistrationDemographicInformation.vue?vue&type=template&id=68254963"
import script from "./RegistrationDemographicInformation.vue?vue&type=script&lang=js"
export * from "./RegistrationDemographicInformation.vue?vue&type=script&lang=js"
import style0 from "./RegistrationDemographicInformation.vue?vue&type=style&index=0&id=68254963&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports